import * as z from 'zod';

import { paymentStatus } from '@/_pages/agreements/shared/installments/schemas/agreement-installments-query-schema';

export const invoicePaymentSyncLineSchema = z.object({
  id: z.number().nullable(),
  amount: z.number(),
  payment_date: z.string(),
  payment_method_id: z.number(),
  payment_status: paymentStatus,
  contact_id: z.number().nullable(),
});

export const invoicePaymentsSyncMutationSchema = z.object({
  payments: z.array(invoicePaymentSyncLineSchema),
});

export type InvoicePaymentSyncLine = z.infer<typeof invoicePaymentSyncLineSchema>;
export type InvoicePaymentsSyncBody = z.infer<typeof invoicePaymentsSyncMutationSchema>;
